import React from 'react';
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button,
  Stack,
  useTheme,
  alpha,
  Divider,
} from "@mui/material";
import {
  ArrowForward,
  CalendarMonth,
  Person,
  MenuBook,
} from "@mui/icons-material";
import WishlistButton from "./WishlistBtn";
import catalogFallback from '../../Images/catalog.png';

export default function Catalog2(props) {
  const navigate = useNavigate();
  const theme = useTheme();

  const viewCourse = () => {
    navigate(`/db-shiksha/kaas/student/course/${props.courseId}`);
  };

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        borderRadius: '24px',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        transition: '0.3s ease',
        '&:hover': {
          borderColor: '#D4AF37',
          boxShadow: `0 10px 30px ${alpha(theme.palette.primary.main, 0.1)}`,
          '& .MuiCardMedia-root': { transform: 'scale(1.05)' }
        },
      }}
    >
      {/* Course Thumbnail */}
      <Box sx={{ 
        width: { xs: '100%', md: 320 }, 
        position: 'relative',
        overflow: 'hidden'
      }}>
        <CardMedia
          component="img"
          image={props.cover_img || catalogFallback}
          alt={props.coursetitle}
          sx={{ 
            height: '100%', 
            minHeight: { xs: 200, md: '100%' },
            transition: '0.6s ease' 
          }}
        />
      </Box>

      {/* Course Content */}
      <CardContent sx={{ flex: 1, p: 4, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h5" fontWeight={800} gutterBottom sx={{ lineHeight: 1.2 }}>
          {props.coursetitle}
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ 
            mb: 3,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            lineHeight: 1.6
          }}
        >
          {props.description}
        </Typography>

        <Stack direction="row" spacing={3} sx={{ mb: 4, flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MenuBook sx={{ fontSize: '1.2rem', color: '#D4AF37' }} />
            <Typography variant="caption" fontWeight={700}>{props.numlesson} Lessons</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarMonth sx={{ fontSize: '1.2rem', color: '#D4AF37' }} />
            <Typography variant="caption" fontWeight={700}>Starts: {props.start_date}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Person sx={{ fontSize: '1.2rem', color: '#D4AF37' }} />
            <Typography variant="caption" fontWeight={700}>By: {props.instructor}</Typography>
          </Box>
        </Stack>

        <Box sx={{ mt: 'auto', pt: 2 }}>
          <Divider sx={{ mb: 3 }} />
          <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
            <Stack direction="row" spacing={2}>
              <Button 
                variant="contained" 
                endIcon={<ArrowForward />}
                onClick={viewCourse}
                sx={{ 
                  borderRadius: '50px', 
                  px: 4, 
                  fontWeight: 800,
                  boxShadow: '0 4px 15px rgba(212, 175, 55, 0.2)'
                }}
              >
                View Details
              </Button>
              <WishlistButton 
                courseId={props.courseId}
                isWishlisted={props.isWishlisted}
                variant="outlined"
              />
            </Stack>
            
            {props.price && (
              <Typography variant="h5" fontWeight={900}>
                ₹{props.price}
              </Typography>
            )}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}
